import React, { ReactElement, useState } from 'react';
import { AccordionWrapper, Button, Content, ContentGrid, HiddenContentGrid, Heading, Line, MainContent } from './style';
import Icon from 'components/Input/Icon';
import { useTheme } from 'providers/ThemeProvider';
export interface AccordionProps {
  title: string;
  mainContent: ReactElement;
  hiddenContent: ReactElement;
  disabled?: boolean;
}

const Accordion = ({ title, mainContent, hiddenContent, disabled }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode } = useTheme();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const iconStyle = {
    transform: isOpen ? 'rotateZ(180deg)' : 'rotate(0)',
    transition: 'transform .5s ease',
    filter: isDarkMode
      // eslint-disable-next-line max-len
      ? 'brightness(0) saturate(100%) invert(86%) sepia(14%) saturate(464%) hue-rotate(136deg) brightness(93%) contrast(92%)'
      : undefined,
  };

  return (
    <AccordionWrapper>
      <Line />
      <Content>
        <ContentGrid>
          <Heading>{title}</Heading>
          {mainContent && <MainContent>{mainContent}</MainContent>}
        </ContentGrid>

        {isOpen && hiddenContent && <HiddenContentGrid>{hiddenContent}</HiddenContentGrid>}
      </Content>

      <Button onClick={toggleAccordion} disabled={disabled}>
        <Icon icon="chevron" style={iconStyle} />
      </Button>
    </AccordionWrapper>
  );
};

export default Accordion;
